import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.a`
    display: flex;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
    height: 100%;
    line-height: 1.3rem;
`
export const IconContainer = styled.div`
    display: flex;
    height: 1.765rem;
`
export const Image = styled.img.attrs({
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/sale.svg`
})`
    height: 100%;
    width: auto;
`
export const Title = styled.span`
    padding: 0 0.8rem;
    color: ${ThemeColors.getGrayColor(1)};
    white-space: nowrap;
`
